<template>
    <div class="side-bar-content">
        <router-link to="/house">
            <div class="side-bar-logo">
                <!--<img src="../assets/powerbee.png" alt="logo">-->
                蜂电科技
            </div>
        </router-link>
        <div class="side-bar">
            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" :router="isRouter"  :collapse="isCollapse">
                <el-menu-item index="/house">
                    <i class="el-icon-location-outline"></i>
                    <span slot="title">房源管理</span>
                </el-menu-item>

                <el-menu-item index="/abnormal">
                    <i class="el-icon-warning"></i>
                    <span slot="title">异常管理</span>
                </el-menu-item>

                <el-menu-item index="/finance">
                    <i class="el-icon-goods"></i>
                    <span slot="title">资金管理</span>
                </el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChildSideBar",
        data() {
            return {
                isCollapse: false,
                isRouter:true,
            }
        },
        methods:{

        }
    }
</script>

<style scoped>
    .side-bar-content {
        width: 1.4rem;
        background-color: #303e51;
        color: #ffffff;
        height: 100%;
        z-index: 5000;
    }

    .side-bar-logo {
        width: 100%;
        height: 0.25rem;
        text-align: center;
        font-size:0.2rem;
        margin:0.1rem 0.2rem 0.1rem 0;
        color: #ffffff;
    }

    .side-bar {
        margin-top: 0.15rem;
    }

    .side-bar, .side-bar > ul {
        height: 100%;
        color: #303e51;
        border: 0;
    }

    .el-menu-vertical-demo{
        background-color: #303e51;
    }

    .el-menu-vertical-demo li:hover{
        background-color: #40536c !important;
        color: #ffffff;
    }

    i{
        color: #e3e3e3;
    }
    .el-menu-vertical-demo li {
        color: #e3e3e3;
        padding: 0 !important;
        padding-left: 0.06rem !important;
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-size: 0.16rem;
    }

    .el-menu-vertical-demo .el-menu-item.is-active {
        background-color: #409EFF !important;
        color: #ffffff;
    }
</style>